import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../Formik'
import { RadioGroup } from '../../../../Radio'
import { TASK_FORM_CONFIGURATION_FIELD_NAME } from '../../TaskForm.constants'

import { Divider } from './Divider'
import { Option } from './Option'

import * as styles from './ConfigurationField.module.css'

function ConfigurationField({ getOptions, ...restProps }) {
  const { t } = useTranslation()

  const options = getOptions()

  return (
    <FormikField
      {...restProps}
      Component={RadioGroup}
      Divider={Divider}
      RadioComponent={Option}
      className={styles.ConfigurationField}
      fieldComponentProps={{
        label: `${t('Task.FormConfigurationFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={TASK_FORM_CONFIGURATION_FIELD_NAME}
      options={options}
    />
  )
}

export default ConfigurationField
